import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.css";
import Home from "./Home/Home";
function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
